import axios from "axios";
import React, { useState } from "react";
import {
  Box,
  Image,
  Spinner,
  useToast,
  Flex,
  HStack,
  Button,
  Icon,
} from "@chakra-ui/react";
import { icons } from "../../utils/icons";
import { newBorder, textSecondary, white, primary } from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { FaCloudArrowUp } from "react-icons/fa6";
import { TbDental } from "react-icons/tb";

const ImageUploadNew = ({
  currentImage,
  image,
  setImage,
  isWhite,
  isLogo,
  w,
  h,
  noToasts,
}) => {
  const [uploading, setUploading] = useState(false);
  const toast = useToast();
  const { t } = useTranslation();

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post("/api/upload", formData, config);

      setImage(data);
      setUploading(false);

      if (noToasts) return;
      // Display success toast
      toast({
        title: t("imageUpload.successTitle"),
        description: t("imageUpload.successDescription"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      setUploading(false);

      // Display error toast
      toast({
        title: t("imageUpload.errorTitle"),
        description: t("imageUpload.errorDescription"),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // console.log(image);

  return (
    <Flex
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      border={`0px dashed ${newBorder}`}
      // borderRadius="0.75rem"
      // p={4}
      // mb={4}
    >
      <HStack spacing={0}>
        {!uploading ? (
          <Box
            w={w ? w : "100px"}
            h={h ? h : "100px"}
            borderRadius="1rem"
            border={`1px solid ${newBorder}`}
            overflow="hidden"
            bg={isWhite ? white : white}
            display="flex"
            alignItems="center"
            justifyContent="center"
            onClick={() => {
              document.getElementById("file-upload").click();
            }}
            transition="all 0.1s ease-in-out"
            _hover={{
              cursor: "pointer",
              border: `1px solid #cbd5e0`,
            }}
            role="group"
          >
            {image ? (
              <Image
                src={currentImage || image || icons.noImage}
                objectFit="cover"
                h="100%"
                w="100%"
              />
            ) : (
              <Flex
                align="center"
                justify="center"
                h="100%"
                w="100%"
                // borderRadius="100%"
                bg={white}
              >
                <Icon as={TbDental} color={textSecondary} fontSize="1.25rem" />
              </Flex>
              // <Image
              //   h="1.25rem"
              //   w="1.25rem"
              //   src={icons.noImage}
              //   transition="all 0.1s ease-in-out"
              //   _groupHover={{ transform: "scale(1.1)" }}
              // />
            )}
          </Box>
        ) : (
          <Box
            w="100px"
            h="100px"
            borderRadius="1rem"
            border={`1px solid ${newBorder}`}
            overflow="hidden"
            bg={white}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="sm" color={primary} />
          </Box>
        )}

        {!image ? (
          // <Stack pl={4} spacing={0}>
          //   <Text color={textPrimary} fontSize="sm" fontWeight="500">
          //     {t("imageUpload.title")}
          //   </Text>
          //   <Text color={textSecondary} fontSize="0.8rem" fontWeight="500">
          //     {t("imageUpload.description")}
          //   </Text>
          // </Stack>
          <Button
            ml={4}
            bg={white}
            color={textSecondary}
            borderRadius="0.75rem"
            border={`1px solid ${newBorder}`}
            size="md"
            fontSize="0.8rem"
            htmlFor="file-upload"
            className="custom-file-upload"
            onClick={() => {
              document.getElementById("file-upload").click();
            }}
          >
            <Icon as={FaCloudArrowUp} fontSize="0.875rem" mr={2} />
            {isLogo ? t("imageUpload.browseLogo") : t("imageUpload.browse")}
          </Button>
        ) : (
          <Button
            ml={4}
            bg={white}
            color={textSecondary}
            borderRadius="1rem"
            border={`1px solid ${newBorder}`}
            size="md"
            fontSize="0.8rem"
            htmlFor="file-upload"
            className="custom-file-upload"
            onClick={() => {
              document.getElementById("file-upload").click();
            }}
          >
            <Icon as={FaCloudArrowUp} fontSize="0.875rem" mr={2} />
            {isLogo
              ? t("imageUpload.changeLogo")
              : t("imageUpload.changeImage")}
          </Button>
        )}

        {/* <Button
          htmlFor="file-upload"
          className="custom-file-upload"
          bg={primary}
          color={white}
          borderRadius="12px"
          p="12px 1.5rem"
          cursor="pointer"
          fontSize="14px"
          fontWeight="500"
          onClick={() => {
            document.getElementById("file-upload").click();
          }}
        >
          <Icon2 src={icons.upload} />
          {image ? t("imageUpload.change") : t("imageUpload.browse")}
        </Button>
     */}
        <input
          id="file-upload"
          type="file"
          onChange={uploadFileHandler}
          style={{ display: "none" }}
        />
      </HStack>
    </Flex>
  );
};

export default ImageUploadNew;
